import React from 'react';
import { testimonials } from '../../data/site';
import { useBrand } from '../../contexts/BrandContext';
export function Testimonial() {
  const featured = testimonials[0];
  const {
    text
  } = useBrand();
  return <section className="bg-cream-deep" data-id="element-115" data-mp="266a5swtmanz6">
      <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-24" data-id="element-116" data-mp="2635ulfhqirz0">
        <blockquote className="mx-auto max-w-4xl text-center" data-id="element-117" data-mp="2b53gyilfm2w6">
          <p className="font-serif text-3xl leading-[1.2] text-ink md:text-[2.75rem]" data-id="element-118" data-mp="2ytefvg7khsht">
            “{text(featured.quote)}”
          </p>
          <footer className="rule mx-auto mt-10 inline-block pt-5 text-sm text-ink-muted" data-id="element-119" data-mp="33sh9m4i3kcah">
            <span className="text-ink" data-id="element-120" data-mp="2psg9ir9np8w2">{featured.name}</span> · {featured.detail}
          </footer>
        </blockquote>
      </div>
    </section>;
}